export default "__VITE_ASSET__DfZPLDum__"